import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import ja from 'vuetify/src/locale/ja';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#0F63BD',
                secondary: '#F5F5F5',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
                cancel: '#777777',
                filterClear: '#888888',
                contentTitle: '#E8EAF6',
                mainTitle: '#606060',
                menuSelected: '#4B82BD',
                menuSelectedText: '4B82BD',
                categorySelected: '0F63BD',
                menuColor: '#FFFFFF',    // 画面左側メニューのテキストやラジオボタンなどに使用
                linkText: '#000000',     // リンクのテキストに使用
                infoHeader: '#555555'  // 登録・編集・削除などのヘッダーテキストに使用
            }
        },
        options: { customProperties: true }
    },
    lang: {
        locales: { ja },
        current: 'ja'
    },
    icons: {
        iconfont: 'mdi'
    }
});
